<template>
  <FormDocument type="Devis" api-type="quotes" />
</template>

<script>
import FormDocument from '@/components/Form/Document'
export default {
  components: {
    FormDocument,
  },
  theme() {
    return {
      title: 'Ajouter une devis',
      subtitle: '',
    }
  },
}
</script>

<style></style>
